import React, { useEffect, useState } from 'react';

const CaseStudiesSection = () => {
  const [visibleCards, setVisibleCards] = useState([]);
  const [showHeading, setShowHeading] = useState(false);
  
  useEffect(() => {
    setTimeout(() => {
      setShowHeading(true);
    }, 300);

    const cardIndexes = [0, 1, 2, 3];
    cardIndexes.forEach((index) => {
      setTimeout(() => {
        setVisibleCards(prev => [...prev, index]);
      }, (index + 1) * 800);
    });
  }, []);

  // Get current window width
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 480;

  const styles = {
    section: {
      minHeight: '100vh',
      position: 'relative',
      overflow: 'hidden',
      padding: '20px 0',
    },
    container: {
      maxWidth: '1200px',
      height: '100%',
      margin: '0 auto',
      padding: '0 15px',
      display: 'flex',
      flexDirection: 'column',
    },
    headingContainer: {
      textAlign: 'center',
      marginBottom: '20px',
      opacity: showHeading ? '1' : '0',
      transform: showHeading ? 'translateY(0)' : 'translateY(30px)',
      transition: 'all 0.8s ease',
    },
    mainHeading: {
      fontSize: isMobile ? '32px' : window.innerWidth <= 768 ? '38px' : '52px',
      color: '#400684',
      fontFamily: '"Oswald", sans-serif',
      fontWeight: '700',
      margin: '0 0 10px 0',
      lineHeight: '1.2',
    },
    headingLine: {
      width: '250px',
      height: '3px',
      background: '#4C1D95',
      margin: '10px auto',
      transition: 'width 0.8s ease',
      transform: showHeading && !isMobile ? 'scaleX(1)' : 'scaleX(0)',
    },
    row: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      flexWrap: 'nowrap',
      margin: isMobile ? '0' : '0 -15px',
      position: 'relative',
      flex: 1,
      gap: isMobile ? '15px' : '0',
    },
    column: {
      flex: isMobile ? '1' : '0 0 33.333333%',
      padding: isMobile ? '0' : '0 15px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: isMobile ? 'flex-start' : 'center',
      gap: '15px',
      width: isMobile ? '100%' : 'auto',
    },
    cardBox: {
      background: '#F8FAFC',
      padding: '15px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
      borderRadius: '10px',
      position: 'relative',
      transition: 'all 0.3s ease',
      display: 'flex',
      flexDirection: isMobile ? 'row' : 'column',
      alignItems: isMobile ? 'center' : 'flex-start',
      gap: isMobile ? '15px' : '6px',
      minHeight: isMobile ? '100px' : '160px',
    },
    numberCircle: {
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      backgroundColor: '#4C1D95',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '12px',
      fontWeight: 'bold',
      flexShrink: 0,
    },
    cardContent: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    },
    link: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#1A202C',
      textDecoration: 'none',
      display: 'block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    description: {
      fontSize: '12px',
      color: '#64748B',
      margin: 0,
      lineHeight: '1.4',
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitLineClamp: '2',
      WebkitBoxOrient: 'vertical',
      textOverflow: 'ellipsis',
    },
    centerImageContainer: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: isMobile ? '20px 0' : 0,
    },
    mainImage: {
      width: isMobile ? '120px' : window.innerWidth <= 768 ? '150px' : '200px',
      height: isMobile ? '120px' : window.innerWidth <= 768 ? '150px' : '200px',
      borderRadius: '50%',
      objectFit: 'cover',
      border: '4px solid white',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
      position: 'relative',
      zIndex: 2,
      transform: showHeading ? 'scale(1)' : 'scale(0.8)',
      opacity: showHeading ? '1' : '0',
      transition: 'all 0.8s ease',
    },
    elementImage: {
      position: 'absolute',
      width: '150px',
      height: '150px',
      zIndex: 1,
      opacity: showHeading && !isMobile ? '1' : '0',
      transition: 'all 0.8s ease',
      display: isMobile ? 'none' : 'block',
    },
  };

  const Card = ({ index, alignment = 'left' }) => (
    <div 
      style={{
        ...styles.cardBox, 
        opacity: '0', 
        animation: `fadeIn 0.8s forwards`,
        textAlign: !isMobile && alignment === 'right' ? 'right' : 'left'
      }}
    >
      <div 
        style={{
          ...styles.numberCircle, 
          marginLeft: !isMobile && alignment === 'right' ? 'auto' : undefined
        }}
      >
        {String(index + 1).padStart(2, '0')}
      </div>
      <div style={styles.cardContent}>
        <a 
          href="/service-single" 
          style={{
            ...styles.link,
            textAlign: !isMobile && alignment === 'right' ? 'right' : 'left'
          }}
        >
          {index === 0 ? 'SAP Solutions' :
           index === 1 ? 'EBS Implementation' :
           index === 2 ? 'Database Administration' :
           'Fusion Cloud Services'}
        </a>
        <p 
          style={{
            ...styles.description,
            textAlign: !isMobile && alignment === 'right' ? 'right' : 'left'
          }}
        >
          {index === 0 ? 'We provide SAP design, implementation, and managed services to ensure your system runs smoothly and efficiently.' :
           index === 1 ? 'We offer Oracle E-Business Suite (EBS) setup and ongoing support to help streamline your business processes.' :
           index === 2 ? 'We manage your databases, ensuring they are secure and up-to-date with regular upgrades and patches.' :
           'We specialize in Oracle Fusion Cloud implementation and management, helping you make the most of cloud technology.'}
        </p>
      </div>
    </div>
  );

  return (
    <div style={styles.section}>
      <div style={styles.container}>
        <div style={styles.headingContainer}>
          <h1 style={styles.mainHeading}>ENTERPRISE SOLUTIONS WE PROVIDE</h1>
          <div style={styles.headingLine}></div>
        </div>
        
        <div style={styles.row}>
          {!isMobile && (
            <>
              <img 
                src="/left_top.png" 
                alt="Top Left" 
                style={{...styles.elementImage, top: '15%', left: '35%', marginLeft: '40px', transform: showHeading ? 'translate(-50%, 0) rotate(0deg)' : 'translate(-50%, -20px) rotate(-45deg)'}} 
              />
              <img 
                src="/right_top.png" 
                alt="Top Right" 
                style={{...styles.elementImage, top: '15%', right: '35%', marginRight: '40px', transform: showHeading ? 'translate(50%, 0) rotate(0deg)' : 'translate(50%, -20px) rotate(45deg)'}} 
              />
              <img 
                src="/left_bottom.png" 
                alt="Bottom Left" 
                style={{...styles.elementImage, bottom: '15%', left: '35%', marginLeft: '40px', transform: showHeading ? 'translate(-50%, 0) rotate(0deg)' : 'translate(-50%, 20px) rotate(45deg)'}} 
              />
              <img 
                src="/right_bottom.png" 
                alt="Bottom Right" 
                style={{...styles.elementImage, bottom: '15%', right: '35%', marginRight: '40px', transform: showHeading ? 'translate(50%, 0) rotate(0deg)' : 'translate(50%, 20px) rotate(-45deg)'}} 
              />
            </>
          )}

          {isMobile ? (
            // Mobile Layout
            <>
              {/* First two cards */}
              {visibleCards.includes(0) && <Card index={0} />}
              {visibleCards.includes(1) && <Card index={1} />}
              
              {/* Center image */}
              <div style={styles.centerImageContainer}>
                <img 
                  src="/about-sm.jpg" 
                  alt="Main" 
                  style={styles.mainImage} 
                />
              </div>
              
              {/* Last two cards */}
              {visibleCards.includes(2) && <Card index={2} />}
              {visibleCards.includes(3) && <Card index={3} />}
            </>
          ) : (
            // Desktop Layout
            <>
              <div style={styles.column}>
                {visibleCards.includes(0) && <Card index={0} alignment="right" />}
                {visibleCards.includes(1) && <Card index={1} alignment="right" />}
              </div>

              <div style={styles.column}>
                <div style={styles.centerImageContainer}>
                  <img 
                    src="/about-sm.jpg" 
                    alt="Main" 
                    style={styles.mainImage} 
                  />
                </div>
              </div>

              <div style={styles.column}>
                {visibleCards.includes(2) && <Card index={2} />}
                {visibleCards.includes(3) && <Card index={3} />}
              </div>
            </>
          )}
        </div>
      </div>

      <style jsx global>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default CaseStudiesSection;